export interface UploadOfferResultDto {
    fileId: string;
    uri: string;
    checksum: string;
    createdAt: string;
    status: OfferFileUploadStatus;
}

export enum OfferFileUploadStatus {
    UPLOADED = 'UPLOADED',
    DUPLICATE = 'DUPLICATE',
}

export interface OfferListItemDto {
    fileId: string;
    fileName: string;
    errorMessage: string | null;
    createdAt: string;
    status: OfferProcessingStatus;
}

export enum OfferProcessingStatus {
    PROCESSING = 'PROCESSING',
    FAILED = 'FAILED',
    QUEUED = 'QUEUED',
    SUCCEEDED_GAEB = 'SUCCEEDED_GAEB',
    SUCCEEDED_JSON = 'SUCCEEDED_JSON',
    SUCCEEDED_JSON_WITH_WARNINGS = 'SUCCEEDED_JSON_WITH_WARNINGS',
    SUCCEEDED_GAEB_WITH_WARNINGS = 'SUCCEEDED_GAEB_WITH_WARNINGS',
    UNKNOWN = 'UNKNOWN',
}

export interface OfferDetail {
    fileId: string;
    fileName: string;
    status: OfferProcessingStatus;
    createdAt: string;
    extractedJson: string | null;
    errorMessage: string | null;
    gaebXml: string | null;
}
